/**
 * Story 049 — shared per-widget error pill.
 *
 * UX brief §3.6 — centered icon + caption + Retry button. Used by all
 * four widgets when their underlying fetch returns a non-404 error.
 */
import type { ReactElement } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { TriangleAlertIcon } from "@aeriosiq/ui/icons";
export interface WidgetRetryPillProps {
  message: string;
  onRetry: () => void;
}

export function WidgetRetryPill({
  message,
  onRetry,
}: WidgetRetryPillProps): ReactElement {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        px: 2,
        py: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <TriangleAlertIcon fontSize="small" sx={{ color: "warning.main" }} />
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          {message}
        </Typography>
      </Stack>
      <Button
        variant="outlined"
        size="small"
        onClick={onRetry}
        sx={{ minHeight: 32 }}
      >
        Retry
      </Button>
    </Box>
  );
}
